<template>
  <div id="app">
   <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
html{
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
body{
  margin: 0;
  padding: 0;
}
#app {
  margin:0;
  padding: 0;
}
#pagemain{
  height: 100%;
  display: flex;
  flex-flow: column;
}
#pageheader{
}

#pagebody{
  flex: 1;
  overflow-y: auto;
  position: relative;
}
.editbody{
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  background: #fff;
}
.editbody-body{
  flex: 1;
  padding: 20px ;
  display: flex;
  overflow: hidden;
}
.editbody-body-box{
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
}
.editbody-body-left{
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.editbody-body-right{
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
}
.editbody-footer{
  padding: 20px;
  text-align: center;
  border-top: 1px solid #d0d0d0;
}
.editpage-close{
  line-height: 20px;
  font-size: 14px;
  color: #409EFF;
  cursor: pointer;
}
.editbody-input{
  width: 240px;
}
.listbody{
  padding: 20px;
  background: #fff;
}
.searchbody{
  background: #fff;
  margin-bottom: 20px;
  padding: 20px 20px 0;
}
.searchbody-cells{
  display: flex;
  flex-wrap: wrap;
}
.searchbody-cell{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.searchbody-cell-hd{
  font-size: 14px;
  color: #777;
  padding-right: 10px;
  min-width: 80px;
  text-align: right;
}
.searchbody-cell-bd{
  display: inline-block;
}
.searchbody-btns{
  padding-left: 20px;
}
/*分页*/
.pagerbox{
  padding: 10px;
  text-align: right;
  display: flex;
  align-items: center;
}
.pagerbox-hd{
  flex: 1;
  text-align: left;
  font-size: 14px;
}

.areadialog .el-dialog__body{
  padding: 0 !important;
}

.levelcolor1{
  color: #000000 !important;
}
.levelcolor2{
  color: #FFBF81 !important;
}
.levelcolor3{
  color: #E39000 !important;
}
.levelcolor4{
  color: #EA5200 !important;
}
.levelcolor5{
  color: #F00005 !important;
}
.cursor-pointer{
  cursor: pointer;
}
.is-link{
  color: #409EFF;
  text-decoration: none;
}
.no-select{
  user-select: none;
}
.nopaddingtbdialog .el-dialog__body{
  padding: 0px 20px !important;
}
.displayflex-center{
  display: flex;
  align-items: center;
}
.marginleft5{
  margin-left: 5px;
}
.marginright5{
  margin-right: 5px;
}
.marginleft10{
  margin-left: 10px;
}
.padding10{padding:10px;}
.paddingtb10{padding: 10px 0;}
.paddinglf5{padding: 0 5px;}

.images-list{
  display: flex;
  flex-wrap: wrap;
}
.images-list-cell{
  position: relative;
  margin: 0 15px 10px 0;
}
.images-list-cell:hover .image-remove{
  display: block;
}
.images-list-img{
  width: 80px;
  height: 80px;
  display: block;
}
.image-remove{
  display: none;
  position: absolute;
  top: -8px;
  right: -8px;
  width: 16px;
  height: 16px;
  background: #999;
  color: #fff;
  border-radius: 8px;
  line-height: 16px;
  text-align: center;
  cursor: pointer;
  font-size: 12px;
}
.editbody-upload-s .el-upload--picture-card{
  width: 82px;
  height: 82px;
  line-height: 82px;
}
.images-list .avatar-uploader-icon {
  font-size: 20px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.user-edit-body{
  display: flex;
  flex: 1;
}
.user-edit-body-left{
  padding-right: 20px;
  flex: 1;
}
.user-edit-body-right{
  padding-left: 20px;
  flex: 1;
  overflow-y: auto;
  border-left: 1px solid #d0d0d0;
}
.area-select{
  cursor: pointer;
}
.area-select span{
  padding-right: 5px;
}
.area-select i{
  color: #C0C4CC;
}
.area-select .area-select-placeholder{
  color: #C0C4CC;
}
</style>
